import { NgModule } from '@angular/core';
import { SlanjeRobePageComponent } from "./slanje-robe-page/slanje-robe-page.component";
import { RouterModule, Routes } from '@angular/router';
import { EotpremnicaFormComponent } from './otpremnice/eotpremnica-form/eotpremnica-form.component';
import { EotpremnicaResolver } from './resolvers/eotpremnica-resolver';
import { EotpremnicaIzPredracunaResolver } from './resolvers/eotpremnica-iz-predracuna-resolver';
import { PrijemRobePageComponent } from './prijem-robe-page/prijem-robe-page.component';
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'slanje-robe',
        data: {
          breadcrumb: 'Slanje robe',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: SlanjeRobePageComponent,
          },
          {
            path: 'unos',
            data: {
              breadcrumb: 'Kreiranje eOtpremnice',
            },
            resolve: {
              // formConfiguration: RacunFormConfigurationResolver,
            },
            component: EotpremnicaFormComponent,
          },
          {
            path: 'unos-iz-predracuna/:predracunId',
            data: {
              breadcrumb: 'Kreiranje eOtpremnice iz predračuna',
            },
            resolve: {
              otpremnica: EotpremnicaIzPredracunaResolver,
            },
            component: EotpremnicaFormComponent,
          },
          {
            path: 'izmena/:id',
            data: {
              breadcrumb: {
                alias: 'izmenaOtpremnice',
              },
            },
            resolve: {
              otpremnica: EotpremnicaResolver,
            },
            component: EotpremnicaFormComponent,
          },
        ]
      },
      {
        path: 'prijem-robe',
        data: {
          breadcrumb: 'Prijem robe',
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: PrijemRobePageComponent,
          },
          {
            path: 'unos',
            data: {
              breadcrumb: 'Kreiranje eOtpremnice',
            },
            resolve: {
              // formConfiguration: RacunFormConfigurationResolver,
            },
            component: EotpremnicaFormComponent,
          },
          {
            path: 'izmena/:id',
            data: {
              breadcrumb: {
                alias: 'izmenaOtpremnice',
              },
            },
            resolve: {
              otpremnica: EotpremnicaResolver,
            },
            component: EotpremnicaFormComponent,
          },
        ]
      },
      // DEFAULT
      { path: '**', redirectTo: '' },
    ],
  },
  { path: '**', redirectTo: 'eotpremnica' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class EOtpremnicaRoutingModule {}
